import { render, staticRenderFns } from "./disciplinas-do-aluno.vue?vue&type=template&id=f1cd1570&"
import script from "./disciplinas-do-aluno.vue?vue&type=script&lang=js&"
export * from "./disciplinas-do-aluno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports